import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { FileText, Linkedin, MessageSquare, Database, Headphones, Bot, Users } from 'lucide-react';
export const Toolkits = () => {
  const resources = [{
    title: 'LinkedIn Optimization Checklist',
    description: 'Boost your visibility and credibility with a structured guide to optimizing your LinkedIn profile for opportunities.',
    icon: <Linkedin size={36} className="text-primary" data-id="element-4846" data-mp="129yajbu5kd70" />,
    emoji: '🚀'
  }, {
    title: 'Networking Scripts & Templates',
    description: 'Sample outreach messages for introductions, collaborations, and event follow-ups that actually work.',
    icon: <MessageSquare size={36} className="text-primary" data-id="element-4847" data-mp="1g7mtge4nta9f" />,
    emoji: '🤝'
  }, {
    title: 'Scholarship & Fellowship Database',
    description: 'Curated list of global leadership, fellowship, and funding programs like Chevening, Acumen, and Mandela Washington.',
    icon: <Database size={36} className="text-primary" data-id="element-4848" data-mp="2roweh53fsacu" />,
    emoji: '👍🏽'
  }, {
    title: 'Opportunity Tracker',
    description: 'Stay organized with a shared tracker for grants, fellowships, speaking gigs, and funding opportunities.',
    icon: <FileText size={36} className="text-primary" data-id="element-4849" data-mp="kclmbbujs5fe" />,
    emoji: '🌏'
  }, {
    title: 'Pitch Deck Template',
    description: 'A clear, investor-ready deck structure to tell your story and win support.',
    icon: <div size={36} className="text-primary" data-id="element-4850" data-mp="ag8s8cv3bpk4" />,
    emoji: '🚀'
  }, {
    title: 'Podcast Starter List',
    description: 'A curated playlist of podcasts on skills, mindset, leadership, and tools for culture shapers.',
    icon: <Headphones size={36} className="text-primary" data-id="element-4851" data-mp="1nf1nja713qy" />,
    emoji: '🎙'
  }, {
    title: 'AI Tools for Culture Shapers',
    description: 'Handpicked free and freemium AI tools for web/app development, marketing, content, graphics, and presentations.',
    icon: <Bot size={36} className="text-primary" data-id="element-4852" data-mp="3iuijwcpp9hns" />,
    emoji: '🤖'
  }, {
    title: 'Community Culture Tools',
    description: 'Frameworks and templates to build trust, collaboration, and strong cultural bonds in communities.',
    icon: <Users size={36} className="text-primary" data-id="element-4853" data-mp="3e82jpxkql610" />,
    emoji: '❤️'
  }];
  return <div className="pt-20" data-id="element-4854" data-mp="307hxerfm4s2r">
      <section className="py-16 bg-secondary/5" data-id="element-4855" data-mp="308b1tlr3n5hq">
        <div className="container mx-auto px-4" data-id="element-4856" data-mp="34820ebmvapwt">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4857" data-mp="348lfzlp1p27o">
            Community Resources Hub
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-4858" data-mp="rlc6x26fdpq">
            Welcome to the Networking Salon Resource Hub — a curated collection
            of tools, templates, and guides designed to help culture shapers,
            leaders, and professionals grow their influence, expand
            opportunities, and strengthen connections. Each resource is
            practical, easy to use, and tailored to support your journey of
            impact and collaboration.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-4859" data-mp="247q555wmjjav">
        <div className="container mx-auto px-4" data-id="element-4860" data-mp="246orqus4ykpz">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-4861" data-mp="1z9ybo7gbzp4k">
            {resources.map((resource, index) => <Card key={index} className="flex flex-col h-full" data-id="element-4862" data-mp="2dx9mg74ov53m" data-mpi={index}>
                <div className="mb-4 flex items-center" data-id="element-4863" data-mp="28zhuxe7yhkzy">
                  <span className="text-3xl mr-3" data-id="element-4864" data-mp="28zzyyx0v13if">{resource.emoji}</span>
                  {resource.icon}
                </div>
                <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-4865" data-mp="1gakcnb3qvo77">
                  {resource.title}
                </h3>
                <p className="text-secondary mb-6 flex-grow" data-id="element-4866" data-mp="1v839l0qkt7pq">
                  {resource.description}
                </p>
                <Button variant="outline" className="mt-auto" data-id="element-4867" data-mp="1q7xbp2tpqoz7">
                  Access Resource
                </Button>
              </Card>)}
          </div>
          <div className="mt-16 p-8 border border-gray-200 rounded-lg bg-secondary/5" data-id="element-4868" data-mp="31o5ixhk3aoh7">
            <h2 className="text-2xl font-bold text-secondary-dark mb-4" data-id="element-4869" data-mp="1b6ry958u3mi7">
              🪪 The Community Directory - Connect with Others
            </h2>
            <p className="text-secondary mb-6" data-id="element-4870" data-mp="1g6o4lb507q0x">
              A searchable member hub to find peers, discover skills, and
              explore collaboration opportunities.
            </p>
            <Button data-id="element-4871" data-mp="1p7ma5xv3c5lm">Access Directory</Button>
          </div>
        </div>
      </section>
    </div>;
};